import CalendarContainer from "@legacy/calendar/CalendarContainer"

import { NavTopBar } from "@organisms"

import { AppFrame } from "@templates"

export default function Calendar() {
    return (
        <AppFrame.Root>
            <NavTopBar.Root>
                <NavTopBar.Header>
                    <NavTopBar.NavTopBarHeaderStart>
                        <NavTopBar.PageTitle label="Calendar" />
                    </NavTopBar.NavTopBarHeaderStart>
                </NavTopBar.Header>
            </NavTopBar.Root>
            <AppFrame.PageContent>
                <CalendarContainer />
            </AppFrame.PageContent>
        </AppFrame.Root>
    )
}
